var React = require('react');

function IconSubheader (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.562 4.615h2.276v4.677h.093c.143-.42.395-.784.754-1.092.359-.308.856-.462 1.492-.462.83 0 1.456.277 1.877.831.43.554.646 1.344.646 2.37V16H7.423v-4.877c0-.523-.082-.908-.246-1.154-.164-.256-.456-.384-.877-.384-.185 0-.364.025-.538.077a1.34 1.34 0 0 0-.477.215c-.134.102-.241.23-.323.384a1.006 1.006 0 0 0-.124.508V16H2.562V4.615Zm9.164 0h2.277v4.677h.092c.144-.42.395-.784.754-1.092.36-.308.857-.462 1.493-.462.83 0 1.456.277 1.877.831.43.554.646 1.344.646 2.37V16h-2.277v-4.877c0-.523-.082-.908-.246-1.154-.165-.256-.457-.384-.877-.384-.185 0-.364.025-.539.077a1.34 1.34 0 0 0-.477.215c-.133.102-.24.23-.323.384a1.007 1.007 0 0 0-.123.508V16h-2.277V4.615Z","fill":"#4D4540"}));
}

IconSubheader.defaultProps = {"fill":"none","viewBox":"0 0 21 20"};

module.exports = IconSubheader;

IconSubheader.default = IconSubheader;
